import type { FaireProductEntity } from "../../entity_types/product";

export const p_v5ezsncy76: FaireProductEntity = {
  token: "p_v5ezsncy76",
  type: "product",
  name: "Green Curry Chimichurri Sauce",
  brandToken: "b_gnxbv2hjdn",
  brandName: "Chin Dribblin' Specialty Asian Fusion Sauces",
  imageUrl:
    "https://cdn.faire.com/fastly/69be7378fe42f7812bda03abd2b8ced92b77b2fc58426aa2a3c0dfc8abdfd9d0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b180ead392880c55175bd5b1d0471320d7d5cf33a77f471603c429abf457e00.jpeg",
    "https://cdn.faire.com/fastly/035561279ce09b9a5925a77e04965fa5ee392f517c1e3d0786e4761d3e798b0b.jpeg",
    "https://cdn.faire.com/fastly/0e00aaa2f94f12fbffc31730f4526eabaf86ebca82e4a872a425907919ee4d15.jpeg",
    "https://cdn.faire.com/fastly/8ab3703379d008758971aeeb9f1fd897472c820a2e6fcdfccf853dc52265305b.jpeg",
    "https://cdn.faire.com/fastly/d0632ade00eda2d5f634a374f628c42b51de6910256234eabcadae4b9126c255.jpeg",
    "https://cdn.faire.com/fastly/6b0d17fe8a4852ac5e72169313afbc5d4092994f952dae1d208ab26e22c4422d.jpeg",
    "https://cdn.faire.com/fastly/d8313b3e9e0a5990d4cdda20a392ce26590e6311fed7db5f431da349fbda29d2.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "A bold fusion of green curry's zesty lemongrass and lime with the herbaceous freshness of cilantro and parsley. Perfect as a marinade, drizzle, or finishing sauce. It adds vibrant flavor to grilled meats, roasted veggies, seafood, and more. Fresh, tangy, and full of life! 🌶️\n\nFeatured on Gordon Ramsay's Food Stars\n\nIngredients: Lime juice, olive oil, cilantro, rice vinegar, cane sugar, parsley, chopped roasted garlic (garlic, water, phosphoric acid, sodium benzoate, and potassium sorbate [preservatives]), green curry paste (green chili pepper, garlic, lemongrass, spices, salt, shallot, lime peel), shallots, sea salt, pepper.\n",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:57.859Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
